// This file is automatically generated. Do not edit manually.

import { CatalogPartRevisionBomTreeViewResult } from "src/api/generated/erp/parts/catalogPart/api/bom/catalogPartRevisionBomTreeViewResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CatalogPartRevisionBomTreeViewApi {
	export async function getTreeElements(args: {
		catalogPartRevisionId: number;
		showRevisions?: boolean;
		searchQuery?: string;
	}): Promise<CatalogPartRevisionBomTreeViewResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/parts/catalogPart/bomTreeView/getTreeElements",
			method: "POST",
			data: {
				catalogPartRevisionId: args.catalogPartRevisionId,
				showRevisions: args.showRevisions,
				searchQuery: args.searchQuery,
			},
		});
		return response as CatalogPartRevisionBomTreeViewResult;
	}
}
